export default "__VITE_ASSET__BP7XJouF__"